module.exports = __webpack_public_path__ + "img/TbClockCancel.807eda91.svg";